import React, { useEffect } from "react"
import ParticleBackground from "./ParticleBackground"
import AuthScene from "./AuthScene"

export function useAuthSceneParallax(shapesRef) {
  useEffect(() => {
    const mq = window.matchMedia("(pointer: fine)")
    const onMove = (e) => {
      if (!mq.matches) return
      const layer = shapesRef.current
      if (!layer) return
      const x = (e.clientX / window.innerWidth - 0.5) * 2
      const y = (e.clientY / window.innerHeight - 0.5) * 2
      layer.style.transform = `rotateX(${y * -2}deg) rotateY(${x * 4}deg)`
    }
    window.addEventListener("mousemove", onMove)
    return () => window.removeEventListener("mousemove", onMove)
  }, [shapesRef])
}

export default function AuthSceneShell({ children, shapesRef }) {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden flex flex-col">
      <ParticleBackground particleCount={18} className="z-0 opacity-10 dark:opacity-6" />
      <AuthScene layerRef={shapesRef} />
      <div className="auth-ambient" aria-hidden />
      <div className="relative z-10 auth-scene flex-1 flex flex-col">{children}</div>
    </div>
  )
}
